export default "__VITE_ASSET__DfINLoz5__"